module.exports = __webpack_public_path__ + "BW.png?9338789d54fb8ca2c103fbc49756e64e";